import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dlKeyValueFilter'
})
export class KeyValueFilterPipe implements PipeTransform {
  transform(dict: Object): Array<any> {
    const a = [];
    for (const key in dict) {
      if (dict.hasOwnProperty(key)) {
        a.push({ key: key, val: dict[key] });
      }
    }
    return a;
  }
}
